import JSX from "../helpers/react.js";
import {tjs} from "../lang.js";


function OneFooterBlock({name, lineWidth}: {name: string, lineWidth: string}, content: any){
    return (
        <div className="one-block">
            <p className="p">{name}</p>
            <div className="line" style={{
                '--width': lineWidth
            }} />
            {...content}
        </div>
    )
}
function Link({href, className}: {href: string, className?: string}, content: any){
    return (
        <a className={"text-wrapper"+(className?' '+className:'')} href={href}>{content}</a>
    );
}
function Icon({icon,href, alt, width, height}: {href: string, alt: string, icon: string, width: number, height: number}){
    return (
        <a href={href} target="_blank" className="icon">
            <img src={"/img/icon/footer/"+icon} alt={alt} width={width} height={height} loading="lazy"/>
        </a>
    )
}
function Icons(){
    return (
        <div className="icons">
            <Icon icon="youtube.svg" alt="YouTube" href="//youtube.com/channel/UCP-IYfKnhDCcZV7sZWG1ZwA"   width={42} height={30}/>
            <Icon icon="boosty.svg" alt="Boosty" href="//boosty.to/yummyanime"  width={33} height={34}/>
            {!is_ukraine && <Icon icon="vk.svg" alt="vk" href="//vk.com/yummyanime_official"  width={37} height={27}/>}
            <Icon icon="discord.svg" alt="Discord" href="//discord.gg/EyXbaRyBcQ"  width={37} height={27}/>
            <Icon icon="tiktok.svg" alt="TikTok" href="//tiktok.com/@yummyani.me"  width={32} height={35}/>
            <Icon icon="telegram.svg" alt="Telegram" href="//yummyanimeru.t.me"  width={37} height={29}/>
            <Icon icon="pikabu.svg" alt="Pikabu" href="//pikabu.ru/@YummyAnime"  width={32} height={32} />
            {/*TODO: return back after RKN unban*/}
            {/*<Icon icon="instagram.svg" alt="Instagram" href="//instagram.com/yummyani.me" width={32} height={32} />*/}

        </div>
    );
}
function LanguageSelect() {
    return (
        <div className="text-wrapper" style={{display: "flex", gap: "10px", height: "25px"}}>
            Language:
            <select id="language-select">
                <option value="ru">🇷🇺 Русский</option>
                <option value="en">🇬🇧 English</option>
                <option value="uk">🇺🇦 Українська</option>
            </select>
        </div>
    );
}

export const Footer = () => {
    const newHost = location.host.includes("yummyani.me") ? `//${__language}.yummyani.me` : `//${__language}.yummy-ani.me`;
    return (
        <footer className="footer bordered-top">
            <div className="container">
                <OneFooterBlock name={tjs('footer_resources')} lineWidth='380px'>
                    <Icons />
                    <div className="logo-bottom">
                        <div className="frame">
                            <img src="/img/yummy-logo.svg" alt="" />
                            <div style={{color: '#D0D0D0'}}>{tjs('footer_disclaimer')}</div>
                        </div>
                    </div>
                </OneFooterBlock>
                <OneFooterBlock name={tjs('footer_site_info')} lineWidth='288px'>
                    <Link href="/pages/about-yummy">{tjs('footer_about')}</Link>
                    <Link href="/pages/rules">{tjs('footer_rules')}</Link>
                    <Link href="/pages/privacy">{tjs('footer_privacy')}</Link>
                    <Link href="/pages/for-rulers">{tjs('footer_rightholders')}</Link>
                    <Link href="/api">{tjs('footer_api')}</Link>
                </OneFooterBlock>
                <OneFooterBlock name={tjs('footer_support')} lineWidth='100%'>
                    <Link href="/users/messages#messages2">{tjs('footer_chat')}</Link>
                    <Link href="//t.me/yummyanidev" className="space">{tjs('footer_dev')}</Link>
                    <LanguageSelect />
                    {/*<div className="text-wrapper space">&nbsp;</div>*/}
                    <div className="text-wrapper">{tjs('footer_email')} <a href="mailto:promotion@yummyani.me" target="_blank">promotion@yummyani.me</a></div>
                    <div className="text-wrapper">{tjs('footer_tg')} <a href={tjs("tg_support")} target="_blank">@YummyAnime_support</a></div>
                </OneFooterBlock>
            </div>

            <a
                className="overlap-group"
                href={newHost + location.pathname + location.search}
            >
                <span className={"new-site"}>{tjs('footer_new')}</span>
            </a>
            <div className="overlap-group">
                <div className="copyright">
                    <b>© {'2022-'+(new Date).getFullYear()} YummyAnime.</b>
                    <span> {tjs('footer_rights')}</span>
                </div>
            </div>
        </footer>
    );
};

$(()=>{
    if(!location.pathname.startsWith('/users/messages'))
        document.querySelector('footer')!.replaceWith(<Footer />)

    const currentLang = __language;
    const parts = location.hostname.split('.');
    const rootDomain = parts.length > 1 ? '.' + parts.slice(-2).join('.') : location.hostname;

    const $langSelect = $('#language-select');
    $langSelect.val(currentLang).slimSelect();
    $langSelect.on('change', function() {
        const lang = $(this).val() as string;
        document.cookie = `language=${lang}; domain=${rootDomain}; path=/; max-age=31536000`;
        location.reload();
    });
})